import React, { Dispatch, SetStateAction, useCallback } from 'react';
import { Box, Grid, Button, Flex } from '../core';
import { AssetData } from '@sc1/common/utils';

interface SelectDataTypeProps {
  setDataType: Dispatch<SetStateAction<AssetData>>;
  dataType: AssetData;
}

export const SelectDataType = ({
  setDataType,
  dataType,
}: SelectDataTypeProps) => {
  const checkButtonTheme = useCallback(
    (x) => (x === dataType ? 'radioButton' : 'radioFaded'),
    [dataType]
  );

  return (
    <Grid gap={3} mt={3}>
      <Box>
        <Box mb={1}>Display Asset Info</Box>
        <Flex>
          <Button
            variant={checkButtonTheme('price')}
            onClick={() => setDataType('price')}
          >
            Price
          </Button>
          <Button
            variant={checkButtonTheme('yield')}
            onClick={() => setDataType('yield')}
          >
            Yield
          </Button>
          <Button
            variant={checkButtonTheme('volatility')}
            onClick={() => setDataType('volatility')}
          >
            Volatility
          </Button>
        </Flex>
      </Box>
    </Grid>
  );
};
